import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardPage.vue?vue&type=style&index=0&id=b3f267d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3f267d2"]])

export default __exports__